import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

(async () => {
	if (typeof YaGames === "undefined" || typeof YaGames.init !== "function") {
		console.error("YaGames SDK not found");
	} else {
		window.ysdk = await YaGames.init();
		console.log("Yandex SDK YaGames");

		window.player = await ysdk.getPlayer();
		console.log("Yandex SDK getPlayer");

		window.lb = await ysdk.getLeaderboards();
		console.log("Yandex SDK getLeaderboards");
	}

	root.render(<App />);
})();
